module.exports = __webpack_public_path__ + "static/media/PORTADA_CICLO_4_ECOSISTÉMICO.c0550af1.jpg";